<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="this.$attrs.editMode  ? 'Edit Referral' :'Add Referral'"            
            v-bind:titleRef="'titleElementReferral'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Fill out the form with as much information as possible. When finished, click <b>Save</b> to continue.
        </p>   
        <b-row>
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Name'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="50"                 
                  v-bind:Name="'Name'"
                  v-model="Referral.displayName"               
                  v-bind:Id="'iName'"/> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Contact'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="30"                
                  v-bind:Name="'icontact'"
                  v-model="Referral.contact"               
                  v-bind:Id="'icontact'"/> 
            </b-col>                      
             <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Phone'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="15" 
                  v-bind:Name="'iPhone'"
                  v-model="Referral.phone"               
                  v-bind:Id="'iPhone'"/> 
            </b-col>
             <b-col lg="3" md="3" sm="12">
               <MdEdit 
                  v-bind:Label="'Cell Phone'"
                  v-bind:TypeProp="'text'"
                  v-bind:MaxLengthProp="15" 
                  v-bind:Name="'iCellPhone'"
                  v-model="Referral.cellPhone"               
                  v-bind:Id="'iCellPhone'"/> 
            </b-col>  
        </b-row>
        
        <b-row>
          <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="'Type of Referral'"
                    v-bind:Options="TypeList"
                    v-bind:FieldDescription="'description'"
                    v-bind:IsDisabled="false"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="Referral.type"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownType"/>
                </b-col> 
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="'Address 1'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'iaddress1'"
                    v-model="Referral.address1"                 
                    v-bind:Id="'iaddress1'"/>   
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Address 2'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'iaddress2'"
                    v-model="Referral.address2"                 
                    v-bind:Id="'iaddress2'"/>      
            </b-col>  
             <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'Zip'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="9" 
                    v-bind:Name="'iZip'"
                    v-on:blur="ZipBlur(Referral.zip)"
                    v-model="Referral.zip"                 
                    v-bind:Id="'iZip'"/>      
            </b-col>           
        </b-row>

        <b-row>
           <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'City'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="255" 
                    v-bind:Name="'icity'"
                    v-model="Referral.city"                 
                    v-bind:Id="'icity'"/>      
            </b-col> 
             <b-col lg="3" md="3" sm="12">
                 <MdEdit 
                    v-bind:Label="'State'"
                    v-bind:TypeProp="'text'"
                    v-bind:isReadOnly="false"
                    v-bind:MaxLengthProp="2" 
                    v-bind:Name="'iState'"
                    v-model="Referral.state"                 
                    v-bind:Id="'iState'"/>
            </b-col>  
            <b-col lg="3" md="3" sm="12">            
                <MdSelect
                    v-bind:Label="'Country'"
                    v-bind:Options="CountryList"
                    v-bind:FieldDescription="'name'"
                    v-bind:IsDisabled="false"
                    v-bind:FieldCode="'recId'"
                    v-bind:Model="Referral.country"                       
                    v-bind:Multiple="false"
                    :Input="ChangeDropDownCountry"/>
            </b-col>  
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnIUserBack'" 
                v-on:click="GoBack"              
                v-bind:ClassProp="'secondary mx-2 btn-login'"
            />  

            <MdButton
                v-bind:isReadOnly="false"
                v-bind:Label="$t('Shared.Save')"
                v-on:click="SaveReferral"
                v-bind:Name="'btnUsers'"
                v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>



    </div>
   

</template>

<script> 
import DBFunctions from '@/common/DBFunctions.js';
import GlobalService from '@/services/global.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import CountryService from '@/services/country.service'
//import EnumService from "@/services/enum.service";
//import EmployeeTypeService from '@/services/employeetypes.service'
//import UsersService from '@/services/users.service'
//import EmployeeCredentialService from '@/services/employeecredential.service'
//import ProviderService from '@/services/provider.service' 
//import Utils from "@/common/utils";
import ISetupService from '@/services/isetup.service'
// v-bind:DataList="dataList"
export default {
  name: 'IniUsers',
  mixins: [ShowMessage, DBFunctions],
  data(){
    return{
      TypeList:[],
      CountryList:[],
      Referral:{
        displayName:"",
        address1:"",
        address2:"",
        city:"",
        state:"",
        zip:"",
        country:"",
        cellPhone:"",
        phone:"",
        fax:"",
        contact:"",
        type:""
      },
      
    }
  },
  methods:{

    GoBack(){
        this.$router.push({ name:'ireferral'});
    },

    
    ChangeDropDownType(item){
      this.Referral.type = item ? item.code : null;
    },
    ChangeDropDownCountry(item){
      this.Referral.country = item ? item.recId : null;
    },

async getAllCountries(){    
      await CountryService.getCountries()
      .then((response) => {      
           if (response.status == "200") {
                this.CountryList = response.data;
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },


    /*validate_required() {
        this.isFirstNameValid = this.User.firstName ? true : false;
        this.isLastNameValid = this.User.lastName ? true : false;      
        this.isEmailValid = this.User.email && Utils.ValidateEmail(this.User.email) ? true : false;    
        
        return this.isFirstNameValid  && this.isLastNameValid && this.isEmailValid;
      },*/

    SaveReferral(){
       // if(this.validate_required()){
            this.$attrs.editMode ? this.Update() : this.Add();
        
        /*}else{
            this.$emit('load', false);
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");
        }*/
        
    },

    ZipBlur: function (value) {
          if(value.trim()!== '') {
            this.$emit('load', true); 
            GlobalService.getCityAndStateByZipCode(value)
                .then((response) => {
                    if(response.status == '200' && response.data){
                        var obj = response.data
                       if(obj.city) {
                            this.Referral.city = obj.city;
                            this.Referral.state = obj.state;
                        }                      
                    }  
                     this.$emit('load', false);                          
                })
                .catch((error) => {
                    this.$emit('load', false); 
                    this.Referral.city = "";
                    this.Referral.state = "";
                  if(error.response.status !== 404 && error.response.status !== 500){
                      if(error.response) {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                    }
                  }
                    
                });  
            }
        },

    Update() {         
    this.$emit('load', true);         
      ISetupService.UpdateReferral(this.$route.params.id,this.Referral)
        .then((response) => {
          if (response.status == '200') {
                this.pendingChanges = false;  
                this.$emit('load', false);
                this.$router.push({name: "ireferral"});
                 setTimeout(() => 
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50);
                               
          }
        })
        .catch((error) => {
          this.$emit('load', false);
          // elemSaveBtn.removeAttribute("disabled"); 
            this.showResponseErrorMessage(error);
        });
    },

     Add() {       
    this.$emit('load', true);         
      ISetupService.AddReferral(this.Referral)
        .then((response) => {
          if (response.status == '200') {
                this.pendingChanges = false;  
                this.$emit('load', false);
                this.$router.push({name: "ireferral"});
                 setTimeout(() => 
                        this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 50);
                               
          }
        })
        .catch((error) => {
          this.$emit('load', false);
          // elemSaveBtn.removeAttribute("disabled"); 
            this.showResponseErrorMessage(error);
        });
    },


    getReferralById(){
        if(this.$attrs.editMode && this.$route.params.id) {
            this.$emit('load', true);
         ISetupService.GetReferral(this.$route.params.id)
            .then((response) => {
               if(response.status == '200' && response.data){
                this.Referral = response.data; 
             //   this.Referral.country = this.Referral.country ? parseInt(this.Referral.country) : this.Referral.country;
                this.$emit('load', false);               
               }
                this.$emit('load', false);
            })
            .catch((error) => {   
                this.$emit('load', false);           
                this.showResponseErrorMessage(error);
               });
         }
      },

    async getTypeReferrals(){    
      await GlobalService.getTypeOfReferrals()
      .then((response) => {      
           if (response.status == "200") {
                this.TypeList = response.data;
           }
      })
      .catch(error => {
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },
    
     
  },

  async created(){
    this.getTypeReferrals();
   await this.getAllCountries();
   this.getReferralById();
  },

  mounted(){
    
  }   
};
</script>


